import { render, staticRenderFns } from "./trade-map-image.vue?vue&type=template&id=07af7952&scoped=true&"
import script from "./trade-map-image.vue?vue&type=script&lang=js&"
export * from "./trade-map-image.vue?vue&type=script&lang=js&"
import style0 from "./trade-map-image.vue?vue&type=style&index=0&id=07af7952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07af7952",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VLayout,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07af7952')) {
      api.createRecord('07af7952', component.options)
    } else {
      api.reload('07af7952', component.options)
    }
    module.hot.accept("./trade-map-image.vue?vue&type=template&id=07af7952&scoped=true&", function () {
      api.rerender('07af7952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/result-components/helpers/trade-map-image.vue"
export default component.exports